<div class="sectionb">


    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [(alertmessage)]="alertmessage"></app-frms-messagebar>
    <ng-container *ngIf="!ismodal">
        <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2">
            <span class="navbar-brand mb-0 h1"> <i class="fas fa-dice-d6"></i> Site Info</span>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="navbar-nav ml-auto">
                    <button
                        *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}"
                        matTooltip="Save site basic data" type="button" class="btn btn-sm  btn-success "
                        [disabled]="!myform.valid||submitted" (click)="saveModel()">
                        <i class="far fa-save"></i> Save
                    </button>
                </div>
            </div>
        </nav>
    </ng-container>
    <div class="container-fluid">
        <div class="row">
            <div class="col" [ngClass]="{ 'col-xl-6': options.mapVisible }">
                <form [formGroup]="myform" class="container-fluid" (ngSubmit)="saveModel()">
                    <p class="form-hint">Fields with * are required</p>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="name"><span class="required-asterisk">*</span>Site
                            name </label>
                        <div class="col-sm-9">
                            <input class="form-control form-control-sm" id="name" formControlName="name" type="text"
                                required placeholder="Enter site name"
                                [ngClass]="!myform.get('name').valid ? 'is-invalid' :'' ">
                            <div class="invalid-feedback" *ngIf="myform.get('name').hasError('required')">
                                Name is required
                            </div>
                            <div class="invalid-feedback" *ngIf="myform.get('name').hasError('minlength')">
                                Name must be at least 3 characters long.
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="description">Description</label>
                        <div class="col-sm-9">
                            <textarea class="form-control form-control-sm" id="description"
                                formControlName="description" rows="4"
                                placeholder="Description about site..."></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="power"><span class="required-asterisk">*</span>Peak
                            Power(MW) </label>
                        <div class="col-sm-4 col-lg-2 col-dlg-3 ">
                            <div class="input-group input-group-sm">
                                <input class="form-control form-control-sm" id="power" formControlName="power"
                                    type="number" required placeholder="Enter power"
                                    [ngClass]="!myform.get('power').valid ? 'is-invalid' :'' ">
                                <div class="input-group-append">
                                    <span class="input-group-text">MW</span>
                                </div>
                            </div>
                            <div class="invalid-feedback" *ngIf="myform.get('power').hasError('required')">
                                Power is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="country">Country </label>

                        <div class="col-sm-4 col-lg-4 col-dlg-1">
                            <select id="country" formControlName="country" class="form-control form-control-sm" required
                                [ngClass]="!myform.get('country').valid ? 'is-invalid' :'' ">
                                <option [ngValue]="null" disabled>Select country</option>
                                <option *ngFor="let item of countries" [ngValue]="item.cca3">
                                    {{ item.name.common}}
                                </option>
                            </select>
                            <div class="invalid-feedback" *ngIf="myform.get('country').hasError('required')">
                                Country is required
                            </div>
                            <!-- <app-countrypicker [setName]="'name.common'" [setValue]="'ccn3'" [flag]="false" [controlname]="'country'"  [form]="myform"></app-countrypicker> -->

                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="zone">Geographical Zone </label>
                        <div class="col col-dlg-3">
                            <input class="form-control form-control-sm" id="zone" formControlName="zone" type="text"
                                placeholder="Enter Geographical zone">
                            <div class="input-hint">Use zone to group sites. </div>
                        </div>
                    </div>
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <b>Map Configuration</b>
                                </mat-panel-title>
                                <mat-panel-description>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <p>GPS coordinates are used to show the site in maps.</p>
                            <div class="form-group row">
                                <label class="col-sm-3 col-form-label" for="longitud"><span
                                        class="required-asterisk">*</span>Location </label>
                                <div class="form-group col-sm-4 col-lg-3 col-dlg-3">
                                    <label class="col-form-label" for="longitud"><span
                                            class="required-asterisk">*</span>longitude </label>
                                    <input class="form-control form-control-sm" step='0.00000000000000001' id="longitud"
                                        formControlName="longitud" type="number" required placeholder="Enter longitude"
                                        [ngClass]="!myform.get('longitud').valid ? 'is-invalid' :'' ">
                                    <div class="invalid-feedback" *ngIf="myform.get('longitud').hasError('required')">
                                        longitude is required
                                    </div>
                                </div>
                                <div class="form-group col-sm-4 col-lg-3 col-dlg-3">
                                    <label class="col-form-label" for="latitud"><span
                                            class="required-asterisk">*</span>latitude </label>
                                    <input class="form-control form-control-sm" step='0.000000000000000001' id="latitud"
                                        formControlName="latitud" type="number" required placeholder="Enter latitude"
                                        [ngClass]="!myform.get('latitud').valid ? 'is-invalid' :'' ">
                                    <div class="invalid-feedback" *ngIf="myform.get('latitud').hasError('required')">
                                        latitude is required
                                    </div>
                                </div>

                            </div>
                        </mat-expansion-panel>
                        <!--                         <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <b>Site administrator</b>
                                </mat-panel-title>
                                <mat-panel-description>
                                    Main contact of the site
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <p>Main contact of the site is used to receive main login/password and notifications.</p>
                        </mat-expansion-panel> -->
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <b>Panels Configuration</b>
                                </mat-panel-title>
                                <mat-panel-description>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            
                            <app-site-config #sitepanelconfig [site]="site"></app-site-config>
                        </mat-expansion-panel>                        
                    </mat-accordion>

                    <!--     <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="geom">* Site Geographical data(EPSG:4326)</label>
            <div class="col-sm-9">
                <div class="invalid-feedback" *ngIf="myform.get('geom').hasError('required')">
                    Site geometry is required in EPSG:4326
                </div>
                <textarea class="form-control form-control-sm" id="geom" formControlName="geom" rows="2"
                    placeholder="Enter valid GeoJson in Geographical Coordinate System (EPSG:4326)"></textarea>

            </div>
        </div> -->
                </form>
            </div>

            <ng-container *ngIf="showMap">
                <div class="col-6">
                    <div style="height: 350px;">
                        <app-ol-main #map [showCardTitle]="false" [showButtonLayers]="true"></app-ol-main>
                    </div>
                    
                </div>
            </ng-container>


        </div>
    </div>

</div>